export default class ParameterBilling {
    constructor() {
        this.number = 0;
    }
    update(data) {
        this.number = data.number;

    }
}